import { ChangeDetectionStrategy, AfterViewInit, Component, inject } from '@angular/core';
import {AuthGuardService} from '../../common/services/auth-guard.service';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-solar-system-page',
  templateUrl: 'solar-system.page.html',
  styleUrls: ['solar-system.page.scss']
})
export class SolarSystemPage implements AfterViewInit {
  private authGuard = inject(AuthGuardService);
  private router = inject(Router);
  private titleService = inject(Title);


  is3DView = false;
  universeMode = 'speed';
  largeZoom = true;
  showData = false;
  showControls = false;
  dataClass = 'earth';

  ngAfterViewInit(): void {
    this.titleService.setTitle('Solar System');
    this.authGuard.loader.set(false);
    this.authGuard.loader$.next(false);

    setTimeout(() => {
      this.is3DView = true;
    }, 3000);
  }

  goToDashboard() {
    this.router.navigateByUrl('/dashboard');
  }
}
